module.exports = __webpack_public_path__ + "assets/cart-4ca80b.svg";